import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import jwt from 'jsonwebtoken';
import { uuid } from '../../utils';
import { environment } from '../../environments/environment';

@Injectable()
export class AppKeyInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const id = uuid();
    const token = jwt.sign({ id }, environment.api_key);
    if (req.url.includes('/api/v1')) {
      const clonedRequest = req.clone({ headers: req.headers.append('Authorization', `Bearer ${token}`) });
      return next.handle(clonedRequest);
    }
    return next.handle(req);
  }
}
